module.exports = __webpack_public_path__ + "img/sprinkle-7.65588f2f.webp";